<button mat-icon-button matTooltip="{{ 'menu.preferences' | translate }}">
    <mat-icon >manage_accounts</mat-icon>
</button>